<template>
  <div :class="['rc-cascader', feedBackShow && 'cascader-height']" @mouseenter.stop="controlMouseOver(component, index)" @click="controlClick(component, index)">
    <el-form-item :class="{'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" :prop="getProp" :rules="rules" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName" :title="component.name" ref='elFormItem' :label-width="labelParameter.width">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <!-- 如果需要改正搜索为第一列则需要修改为只使用框架的级联面板, 样式需要调整 -->
      <!--<el-input :value="currentValue.join('/')" disabled @click.native="show = !show"></el-input>-->
      <!--<el-cascader-panel-->
        <!--v-show="show"-->
        <!--v-loading="loading"-->
        <!--ref="rcCascader"-->
        <!--:value="currentValue"-->
        <!--:props="props"-->
        <!--:options="options"-->
        <!--:disabled="disabled || component.properties.readonly"-->
        <!--clearable-->
        <!--@change="handleChange"></el-cascader-panel>-->
      <!-- 使用一个文本框来单独处理回显问题 -->
      <el-input :value="feedBackShowValue" v-show="feedBackShow"
                :class="['feed-back-show-input', inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
                :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
                clearable
                :title="feedBackShowValue"
                @change="feedBackShowChange"
                @click.native="hideFeedBack"
                :placeholder="component.properties.placeholder"
                :disabled="disabled || component.properties.readonly"></el-input>
      <el-cascader
        :class="[feedBackShow && 'cascader-position', inputWidth && Number(inputWidth) < 30 && 'clear-padding', component.properties.hidden && 'cascader-hidden']"
        :style="{visibility: !feedBackShow ? 'visible' : 'hidden', width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
        popper-class="rc-cascader-panel"
        ref="rcCascader"
        :title="showValue"
        :value="currentValue"
        :props="props"
        :options="options"
        :disabled="disabled || component.properties.readonly"
        :placeholder="component.properties.placeholder"
        filterable
        clearable
        @expand-change="expandChangeFilters"
        @change="handleChange">
        <template slot-scope="{ node, data }">
          <span :title="data.label">{{ data.label }}</span>
        </template>
      </el-cascader>
    </el-form-item>
  </div>
</template>

<script>
import {componentMixin, inputMixin, relFunMixin} from './mixins'

export default {
  name: 'rc-cascader',
  mixins: [componentMixin, inputMixin, relFunMixin],
  props: ['component', 'value', 'index', 'disabled', 'labelParameter', 'tableCtrlKey'],
  inject: ['initState', 'dataService'],
  data () {
    return {
      // show: false,
      // loading: false,
      feedBackShow: false,
      feedBackShowValue: '',
      showValue: '',
      currentValue: [],
      originalOptions: [],
      options: [],
      filters: [],
      props: {
        lazy: true,
        lazyLoad: this.lazyLoad
      }
    }
  },
  created () {
    if (this.index !== undefined && this.initState.state) {
      this.getOptions(0)
      this.getOriginalOptions(0)
    }
  },
  watch: {
    'initState.state' (val) {
      if (val) {
        this.getOptions(0)
        this.getOriginalOptions(0)
        this.showFeedBack()
      }
    },
    value (val) {
      if (val || val === 0) {
        this.currentValue = String(val).split('/')
      }
    }
  },
  methods: {
    // 懒加载
    async lazyLoad (node, resolve) {
      const { level, value } = node
      if (level > 0) {
        let options = []
        // 配置筛选条件, 存在多个，首次如果不在这里配置，下面的expand-change触发会在懒加载之后
        this.$set(this.filters, level - 1, value || '')
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        options = await this.getOptions(level)
        resolve(options)
      }
    },
    getOptions (level) {
      let options = []
      // 需要传展示的文本的id给后端去重
      let distinctColumnId = []
      this.component.properties.settingCascader.cascaderOptions.slice(0, level + 1).forEach((e, i) => {
        distinctColumnId.push(e.optionId)
      })
      let params = {
        filters: {
          distinctColumnId: distinctColumnId.join(',')
        }
      }
      let cascaderOptions = this.component.properties.settingCascader.cascaderOptions
      // 层层的筛选条件 curretValue是数组, 按层级排列, filters的第0项时empty因为从第一层才开始筛选, 第0层的搜索使用filter方法重写
      if (level > 0 && this.filters.length > 0) {
        // 以选项id作为筛选列 , 选项文本对应的选项id值作为筛选的值
        for (let i = 0; i < level; i++) {
          params.filters[cascaderOptions[i].optionId] = this.filters[i]
        }
      }
      // if (level === 0) {
      //   this.loading = true
      // }
      // 获取绑定的辅助表所有数据, 筛选条件没传时后端限制1000条
      return this.$axios.get(`/report-api/report/data/data/byColumnId/${this.component.properties.settingCascader.dataSourceReportId}`, {params: params}).then(res => {
        // 使用选项一optionId的值作为value, optionShowId作为label
        let value = cascaderOptions[level].optionId
        let label = cascaderOptions[level].optionShowId
        options = res.data.map(e => {
          return {
            value: typeof e[value] === 'number' ? String(e[value]) : e[value],
            label: typeof e[label] === 'number' ? String(e[label]) : e[label],
            leaf: level === cascaderOptions.length - 1
          }
        })
        if (level === 0) {
          this.options = options
          // this.loading = false
        }
        return options
      })
    },
    // 获取未去重过的数据用以数据绑定 todo: 如果要实现搜索, 每次搜索之后这里也需要重新获取
    getOriginalOptions () {
      this.$axios.get(`/report-api/report/data/data/byColumnId/${this.component.properties.settingCascader.dataSourceReportId}`).then(res => {
        this.originalOptions = res.data
      })
    },
    // 级联数据会缓存，缓存之后不再进懒加载导致筛选条件不改变，所以需要在这里改变，首次会重复修改，但无影响
    expandChangeFilters (arr) {
      this.filters = arr
    },
    handleChange (val) {
      this.currentValue = val
      this.feedBackShow = false
      if (this.component.archive.enable) {
        // 开启了归档才更新值
        if (val === null || val === undefined) {
          this.update('')
        } else {
          // 更新归档字段
          this.update(val.join('/'))
          // 更新归档文本
          this.updateShowValue(val)
        }
        // 开启了绑定数据源
        if (this.component.properties.settingCascader.bindData.enable && this.component.properties.settingCascader.bindData.dataBinding.length > 0) {
          let cascaderOptions = this.component.properties.settingCascader.cascaderOptions
          // 找到选项id对应值的那一项
          this.component.properties.settingCascader.bindData.dataBinding.forEach(e => {
            let value = this.originalOptions.find(op => {
              let flag = 0
              // 存在多个选项id, 要这些选项id都相等
              for (let i = 0; i < cascaderOptions.length; i++) {
                if (String(op[cascaderOptions[i]['optionId']]) === val[i]) {
                  flag++
                }
              }
              return flag === cascaderOptions.length
            })
            this.update({'value': (value && value[e.showColumnId]) || '', 'archiveColumnId': e.componentId})
          })
        }
      }
    },
    updateShowValue (val) {
      if (!val || (Array.isArray(val) && val.length === 0)) {
        return this.update({value: '', archiveColumnId: this.component.properties.archived.showColumnId})
      }
      // 归档文本数组
      let showValueArray = []
      // 单选只有一项
      showValueArray = this.getShowValueArray(showValueArray, this.$refs.rcCascader.getCheckedNodes()[0])
      this.showValue = showValueArray.reverse().join('/')
      this.update({value: this.showValue, archiveColumnId: this.component.properties.archived.showColumnId})
    },
    getShowValueArray (showValueArray, node) {
      if (node.label) {
        showValueArray.push(node.label)
      }
      if (node.parent) {
        this.getShowValueArray(showValueArray, node.parent)
      }
      return showValueArray
    },
    showFeedBack () {
      // 编辑的时候使用回显文本框来展示值
      if (this.dataService.data.dataState === 'update' || this.value || this.value === 0) {
        this.feedBackShow = true
        // 表格内的回显
        if (this.index !== undefined && this.parentPath && this.parentPath[1]) {
          this.feedBackShowValue = this.dataService.data[this.parentPath[1]][this.index][this.component.properties.archived.showColumnId]
        } else {
          this.feedBackShowValue = this.dataService.data[this.component.properties.archived.showColumnId]
        }
        // 显示样式
        this.feedBackShowValue = this.feedBackShowValue.replace(/\//g, ' / ')
      }
    },
    hideFeedBack () {
      this.$refs.rcCascader.$el.click()
    },
    // 用来回显的值删除时也要清除归档值
    feedBackShowChange (val) {
      if (val === '') {
        this.handleChange([])
        this.$refs.rcCascader.$el.blur()
      }
    }
  }
}
</script>
<style lang="scss">
.rc-cascader{
  &.cascader-height{
    height: 28px;
  }
  .el-form-item{
    .el-form-item__content{
      .el-input.feed-back-show-input{
        input{
          cursor: pointer;
        }
      }
      .el-cascader{
        width: 100%;
        /* 处理展示回显框时级联面板的弹出位置 */
        &.cascader-position{
          position: relative;
          top: -28px;
          z-index: -1;
        }
        /* 开启隐藏占位后由于visibility的继承性，隐藏属性被框架覆盖了，这里需要强制隐藏*/
        &.cascader-hidden{
          display: none;
        }
      }
    }
  }
}
  .rc-cascader-panel{
    .el-cascader-panel{
      .el-cascader-menu{
        .el-cascader-node:not(.is-disabled):hover,.el-cascader-node:not(.is-disabled):focus{
          background-color: var(--light-9, #F5F7FA);
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-cascader.vue